export default "__VITE_ASSET__BQ6ugrOs__"